var React = require('react');

function ToggleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.5 2L13 8.5L11.6295 9.87054L6.5 4.74109L1.37054 9.87054L0 8.5L6.5 2Z","fill":"#102B2D"}));
}

ToggleInline.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none"};

module.exports = ToggleInline;

ToggleInline.default = ToggleInline;
